import "core-js/modules/es.array.push.js";
export default {
  name: "mBtnMathine",
  props: {},
  computed: {},
  data() {
    return {
      popPromptInfo: null,
      popPromptShow: false
    };
  },
  watch: {
    watch: {
      isLogin: {
        async handler(bool) {
          if (bool) {}
        },
        deep: true,
        immediate: true
      }
    }
  },
  methods: {
    showPop() {
      this.$router.push("/slotMachine");
    }
  },
  mounted() {}
};